<div class="persona-info">

  <div role="content" class="persona-info-content">
    @if (!ready) {
      <div>
        <se-fe-spinner
          seFeDataSize="950"
          [seFeDataInverted]="false"
          [seFeDataCenter]="true"
        ></se-fe-spinner>
      </div>
    }
    @if (ready) {
      <form
        [formGroup]="form"
        novalidate>
        <section>
          @if (isEnabled('name')) {
            <div class="form-field">
              <se-po-name
                [seFeDataLabel]="labelName"
                formControlName="name"
                enablePreferred="true"
                enableSuffix="true"
                [maxLength]="maxNameLength">
              </se-po-name>
            </div>
          }
          @if (isEnabled('gender')) {
            <div class="form-field fitted-field">
              <se-po-gender-select
                formControlName="gender"
                [seFeDataLabel]="labelGender"
                [disabled]="genderDisabled"
              ></se-po-gender-select>
            </div>
          }
          @if (isEnabled('dateOfBirth')) {
            <div class="form-field fitted-field">
              <se-po-dob-select
                formControlName="dateOfBirth"
                [seFeDataLabel]="labelDateOfBirth"
              ></se-po-dob-select>
              @if (accountAgeRequired && showDateOfBirthLearnMore) {
                <se-fe-form-control-help>
                  <button type="button"
                    class="popover-link"
                    [seFePopoverTrigger]="dateOfBirthLearnMore"
                    seFeLink>
                    Learn more
                  </button>
                  <se-fe-popover #dateOfBirthLearnMore>
                    <p>If you are a parent/guardian signing up your child, add your name and
                      date of birth here first. You'll have the opportunity to create your child's
                      profile later.
                    </p>
                  </se-fe-popover>
                </se-fe-form-control-help>
              }
            </div>
          }
          @if (isEnabled('gradYear')) {
            <div class="form-field fitted-field">
              <se-po-graduation-select
                formControlName="gradYear"
                [seFeDataLabel]="labelGradYear"
              ></se-po-graduation-select>
            </div>
          }
        </section>
      </form>
    }
  </div>
</div>
